"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fakeVehiclesApi = exports.fakeVehicleApi = exports.fakeModelsApi = undefined;

var _modelsAcura = require("./models-acura");

var _modelsAcura2 = _interopRequireDefault(_modelsAcura);

var _modelsBmw = require("./models-bmw");

var _modelsBmw2 = _interopRequireDefault(_modelsBmw);

var _modelsCadillac = require("./models-cadillac");

var _modelsCadillac2 = _interopRequireDefault(_modelsCadillac);

var _vehicles = require("./vehicles");

var _vehicles2 = _interopRequireDefault(_vehicles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELAY_MS = 1000;
// const DELAY_MS = 10;

var fakeModelsApi = exports.fakeModelsApi = function fakeModelsApi(make) {
  var models = void 0;
  switch (make) {
    case "Acura":
      models = _modelsAcura2.default;
      break;
    case "BMW":
      models = _modelsBmw2.default;
      break;
    case "Cadillac":
      models = _modelsCadillac2.default;
      break;
    default:
      models = [];
  }
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(models);
    }, DELAY_MS);
  });
};

var fakeVehicleApi = exports.fakeVehicleApi = function fakeVehicleApi(vehicleId) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      var vehicle = _vehicles2.default.find(function (v) {
        return v.id === vehicleId;
      }) || {};
      resolve(vehicle);
    }, DELAY_MS);
  });
};

var fakeVehiclesApi = exports.fakeVehiclesApi = function fakeVehiclesApi() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var make = params.make,
      model = params.model;

  return new Promise(function (resolve) {
    setTimeout(function () {
      var filteredVehicles = _vehicles2.default;
      if (make) {
        filteredVehicles = filteredVehicles.filter(function (v) {
          return v.make === make;
        });
      }
      if (model) {
        filteredVehicles = filteredVehicles.filter(function (v) {
          return v.model === model;
        });
      }
      resolve(filteredVehicles);
    }, DELAY_MS);
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fake-vehicle-apis/lib/index.js
// module id = 109
// module chunks = 0